export default function RowItemSubheader({ children }) {
	return <i>{children}</i>;
}
